// Zone del carrello/preventivo (es. Cucina, Soggiorno): le righe con la stessa zona
// stanno insieme e hanno lo stesso colore tenue. Usato da Cart.js, CartContext e dal PDF ordine.

// bg = sfondo riga (tenue), accent = banda/intestazione zona.
export const ZONE_COLORS = [
  { bg: '#EAF6EC', accent: '#5FB66B' }, // verde
  { bg: '#FFF8E1', accent: '#E0A800' }, // giallo
  { bg: '#E8F2FC', accent: '#4A90D9' }, // azzurro
  { bg: '#FCEBF1', accent: '#D9648F' }, // rosa
  { bg: '#F2ECF8', accent: '#9B6BC9' }, // lilla
  { bg: '#E6F5F3', accent: '#3BA99C' }, // verde acqua
  { bg: '#FFF0E3', accent: '#E58B3A' }, // arancio
  { bg: '#EEF0F3', accent: '#7A8494' }, // grigio
];

export const normalizeZone = (zone) => String(zone ?? '').trim();
const zoneKey = (zone) => normalizeZone(zone).toLowerCase();
export const sameZone = (a, b) => zoneKey(a?.zone) === zoneKey(b?.zone);

const getPosition = (item, index) => (Number.isFinite(item?.position) ? item.position : index + 1);

// Ordina le righe per zona (zone nell'ordine in cui compaiono la prima volta),
// mantenendo dentro ogni zona l'ordine manuale (position). Senza zone l'ordine non cambia.
export const groupByZone = (items = []) => {
  const sorted = items
    .map((item, index) => ({ item, pos: getPosition(item, index) }))
    .sort((a, b) => a.pos - b.pos)
    .map(({ item }) => item);
  const groups = new Map();
  sorted.forEach((item) => {
    const key = zoneKey(item.zone);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(item);
  });
  return [...groups.values()].flat();
};

// Stesse righe raggruppate, con position rinumerata 1..n nell'ordine raggruppato.
export const regroupAndRenumber = (items = []) =>
  groupByZone(items).map((item, idx) => ({ ...item, position: idx + 1 }));

// Colore per ogni zona con nome, assegnato nell'ordine di comparsa.
export const getZoneColor = (items = []) => {
  const map = new Map();
  groupByZone(items).forEach((item) => {
    const key = zoneKey(item.zone);
    if (key && !map.has(key)) map.set(key, ZONE_COLORS[map.size % ZONE_COLORS.length]);
  });
  return (zone) => map.get(zoneKey(zone)) || null;
};

// Elenco zone distinte (per i suggerimenti nel campo Zona).
export const listZones = (items = []) => {
  const seen = new Map();
  items.forEach((item) => {
    const zone = normalizeZone(item.zone);
    if (zone && !seen.has(zone.toLowerCase())) seen.set(zone.toLowerCase(), zone);
  });
  return [...seen.values()];
};

export const hexToRgb = (hex) => {
  const n = parseInt(String(hex).replace('#', ''), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};
